import { SearchField } from "@tm/components"
import { useState } from "react"
import { useLocalization } from "@tm/localization"
import { createQueryString } from "@tm/utils"
import { useHistory } from "react-router"

export type Props = {
    query?: string
    hideClearButton?: boolean
    url: string
    variant?: "widget" | "header"
}

export function ArticleSearchFields({ query, hideClearButton, url, variant }: Props) {
    const { translateText } = useLocalization()
    const history = useHistory()

    const [searchQuery, setSearchQuery] = useState(query ?? "")

    function handleSearchInputChange(newQuery: string) {
        setSearchQuery(newQuery)
    }

    function handleSearch() {
        let newUrl = url
        newUrl += createQueryString({ searchQuery })

        history.push(newUrl)
    }

    const handleKeyDown = (e: { key: string }) => {
        if (e.key === "Enter") {
            handleSearch()
        }
    }

    return (
        <SearchField
            onKeyDown={handleKeyDown}
            onChange={(value) => handleSearchInputChange(value)}
            value={searchQuery}
            onStartSearch={handleSearch}
            placeholder={translateText(87)}
            hiddenLabel
            fullWidth
            hideClearButton={hideClearButton}
            size={variant === "widget" ? "medium" : "large"}
            sx={{ width: "225px" }}
        />
    )
}
